import { useEffect, useState } from 'react'

import { getReworkReasons } from '@pepper/utils/src/function/misc'

import { useUtils } from '../providers'

interface Payload {
  type: 'text' | 'translation' | 'design' | 'others'
  getFlaggingOption?: boolean
}

export function useFeedbackOptions({
  type,
  getFlaggingOption = false
}: Payload): ReworkAreasInput {
  const { feedback_inputs: inputs, rework_areas: reworks } = useUtils()
  const [reworkAreasInput, setReworkAreasInput] = useState<ReworkAreasInput>([])

  useEffect(() => {
    const result: ReworkAreasInput = []
    let hasAllReworkInputAreas: boolean

    reworks.forEach(rework_area => {
      const filteredInputs: { id: number; title: string }[] = []
      if (getFlaggingOption) {
        hasAllReworkInputAreas =
          getReworkReasons(type).includes(rework_area.key) ||
          rework_area.key === 'flag_creator'
      } else {
        hasAllReworkInputAreas = getReworkReasons(type).includes(
          rework_area.key
        )
      }

      if (hasAllReworkInputAreas) {
        rework_area.inputs.forEach(input => {
          const matched = inputs.find(fi => fi.id === input)

          if (matched) {
            filteredInputs.push(matched)
          }
        })

        result.push({
          title: rework_area.title,
          key: rework_area.key,
          id: rework_area.id,
          rework_inputs: filteredInputs
        })
      }
    })

    const firstReworkOption = result.find(
      rework => rework.key === 'additional_feedback'
    )

    if (!firstReworkOption) {
      setReworkAreasInput(result)
    }

    const sorted = [
      ...(firstReworkOption ? [firstReworkOption] : []),
      ...result.filter(rework => rework.key !== 'additional_feedback')
    ] as ReworkAreasInput

    setReworkAreasInput(sorted)
  }, [getFlaggingOption, inputs, reworks, type])

  return reworkAreasInput
}
